import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import {
  MDBCol,
  MDBContainer,
  MDBRow,
  MDBCard,
  MDBCardText,
  MDBCardBody,
} from "mdb-react-ui-kit";
import axios from "axios";

const ViewOrderReturn = () => {
  const { id } = useParams();

  const [singleOrder, setSingleOrder] = useState([]);
  const [singleOrderdetail, setSingleOrderdetail] = useState("");
  const [invoice, setInvoice] = useState("");
  const [setting, setSetting] = useState("");
  const [amount, setAmount] = useState("");
  const [orderNo, setOrderNo] = useState("");
  const [status, setStatus] = useState("");

  const [shipAddress1, setShipAddress1] = useState("");
  const [shipAddress2, setShipAddress2] = useState("");

  const [shipAddress3, setShipAddress3] = useState("");

  const [image, setImage] = useState("");

  const [reason, setReason] = useState("");

  useEffect(() => {
    loadCustomer();
  }, []);

  const loadCustomer = async () => {
    const result = await axios.get("/api/single_return_order/" + id);
    setSingleOrder(result.data.data);
    setSingleOrderdetail(result.data.order.customer);
    setInvoice(result.data.invoice);
    setAmount(result.data.order.total);
    setOrderNo(result.data.order);
    setStatus(result.data.order);
    setReason(result.data.order.app_reason);
    setShipAddress1(result.data.order.ship_city);
    setShipAddress2(result.data.order.ship_state);

    setShipAddress3(result.data.order.ship_country);
  };

  useEffect(() => {
    axios.get("/api/get_settings").then((res) => {
      setSetting(res.data.data);
      setImage(res.data.data.logo);
    });
  }, []);
  const columns = [
    {
      name: "#",
      selector: (row, index) => index + 1,
      width: "70px",
    },

    {
      name: "Product Id",
      selector: (row, index) => row.product_id,
      width: "130px",
    },

    {
      name: "Product",
      selector: (row) => {
        const productName = row.product.product_name
          ? row.product.product_name
          : "Not Available";
        if (productName.length > 20) {
          return (
            <div
              className="text-capital"
              style={{ whiteSpace: "pre-line", width: "170px" }}
            >
              {productName.match(new RegExp(".{1," + 20 + "}", "g")).join("\n")}
            </div>
          );
        } else {
          return <span className="text-capital">{productName}</span>;
        }
      },
      width: "170px",
    },

    {
      name: "Batch",
      selector: (row) => row.batch_number,
      width: "100px",
    },

    {
      name: "Disc",
      selector: (row) => <span>{row.discount + "%"}</span>,

      width: "100px",
    },

    {
      name: "Discount Price",
      selector: (row) => <span>{row.discounted_price}</span>,

      width: "130px",
    },

    {
      name: "GST",
      selector: (row) => <span>{row.gst + "%"}</span>,
      width: "80px",
    },

    {
      name: "Sale Rate",
      selector: (row) => Number(row.sale_rate).toFixed(2),

      width: "100px",
    },

    {
      name: "Qty",
      selector: (row) => row.quantity,
      width: "100px",
    },
  ];

  const statuschange = async (e) => {
    e.preventDefault();
    const productobj = new FormData();
    productobj.append("order_status", e.target.value);
    await axios
      .post("/api/update_order_return/" + id, productobj, {
        headers: {
          Accept: "application/json",
        },
      })
      .then((result) => {})
      .catch((error) => {});
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (!localStorage.getItem("status")) {
      navigate("/");
    }
  }, [navigate]);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-2 p-0">
          <Sidebar />
        </div>
        <div className="col-sm-10">
          <div className="container-fluid">
            <Navbar />

            <div className="p-2 bg-white ml-3">
              <span>
                <Link to="/dashboard">Dashboard</Link> /{" "}
                <Link to="/order-returns">Order Return</Link> / View
              </span>
            </div>

            <section
              className="bg-gre ml-3"
              style={{
                padding: "10px 0px 30px 0",
                minHeight: "570px",
              }}
            >
              <MDBContainer className="px-5 mt-4">
                <MDBRow>
                  <MDBCol lg="12">
                    <MDBCard className="mb-2">
                      <MDBCardBody>
                        <MDBRow>
                          <MDBCol
                            sm="4"
                            className="border-right"
                            style={{ fontSize: "14px" }}
                          >
                            <MDBCardText>
                              <span>
                                <strong>{singleOrderdetail.name}</strong>
                              </span>
                            </MDBCardText>

                            <MDBCardText>
                              <span>{singleOrderdetail.email}</span>
                            </MDBCardText>

                            <MDBCardText>
                              <span>{singleOrderdetail.mobile}</span>
                            </MDBCardText>

                            <MDBCardText>
                              <span>{singleOrderdetail.total}</span>
                            </MDBCardText>
                            <MDBCardText>
                              <span>
                                {singleOrderdetail.shop_address1 +
                                  " , " +
                                  shipAddress1.name +
                                  " , " +
                                  shipAddress2.name +
                                  " , " +
                                  shipAddress3}
                              </span>
                            </MDBCardText>
                            <MDBCardText>
                              Order No.-
                              <span>{orderNo.order_number}</span>
                            </MDBCardText>
                            <MDBCardText>
                              Reason for Cancel -
                              <span style={{ color: "red" }}>
                                {" "}
                                {orderNo.app_reason}
                              </span>
                            </MDBCardText>
                          </MDBCol>

                          <MDBCol
                            sm="3"
                            className="border-right"
                            style={{ fontSize: "14px" }}
                          >
                            <MDBCardText>
                              <span className="fw-600">
                                <strong>{setting.company_name}</strong>
                              </span>
                            </MDBCardText>

                            <MDBCardText>
                              <span className="fw-600">{setting.email}</span>
                            </MDBCardText>

                            <MDBCardText>
                              <span className="fw-600">{setting.phone}</span>
                            </MDBCardText>

                            <MDBCardText>
                              <span className="fw-600">{setting.website}</span>
                            </MDBCardText>

                            <MDBCardText>
                              <span className="fw-600">{setting.address}</span>
                            </MDBCardText>
                          </MDBCol>

                          <MDBCol className="d-flex align-items-center" sm="4">
                            <img
                              src={image}
                              className="rounded mx-auto d-block"
                              alt="Logo"
                              width={180}
                            />
                          </MDBCol>
                        </MDBRow>
                        <hr />

                        <MDBRow className="mt-1">
                          <div style={{ margin: "1%" }}>
                            <DataTable
                              columns={columns}
                              title="Order Detail"
                              data={singleOrder}
                              defaultSortFieldId
                              fixedHeader
                              responsive
                              allowOverflow
                              subHeaderAlign="right"
                            />
                          </div>
                        </MDBRow>
                        <hr></hr>

                        <MDBRow className="mt-2">
                          <MDBCol sm="5"></MDBCol>
                          <MDBCol sm="4"></MDBCol>
                          <MDBCol sm="3">
                            <MDBCardText style={{ fontSize: "25px" }}>
                              Total :{" "}
                              <span
                                style={{ fontSize: "25px", fontWeight: "700" }}
                              >
                                ₹ {parseFloat(amount).toFixed(2)}
                              </span>
                            </MDBCardText>
                          </MDBCol>
                        </MDBRow>
                        <MDBRow>
                          <MDBCol sm="8">
                            <MDBCardText>
                              Change Status :{" "}
                              <select onChange={statuschange}>
                                <option
                                  selected={status.order_status == "0"}
                                  value="0"
                                >
                                  Processing
                                </option>
                                <option
                                  selected={status.order_status == "1"}
                                  value="1"
                                >
                                  Complete
                                </option>
                              </select>
                            </MDBCardText>
                          </MDBCol>
                        </MDBRow>
                      </MDBCardBody>
                    </MDBCard>
                  </MDBCol>
                </MDBRow>
              </MDBContainer>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewOrderReturn;
